import { ChangeDetectionStrategy, Component, inject, OnDestroy, OnInit } from '@angular/core'
import { RouterOutlet } from '@angular/router'

import { TranslateService } from '@ngx-translate/core'
import { filter, map, takeUntil, tap, withLatestFrom } from 'rxjs/operators'

import { DestroyDirective } from '~/core/directives'
import { CompanyFacade } from '~/core/features'
import { IForecastDto } from '~/core/models'
import { MetaTagService } from '~/core/services'

@Component({
  selector: 'app-company',
  templateUrl: './company.component.html',
  styleUrl: './company.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  hostDirectives: [DestroyDirective],
  imports: [RouterOutlet],
})
export class CompanyComponent implements OnInit, OnDestroy {
  private readonly translateService = inject(TranslateService)
  private readonly metaTagService = inject(MetaTagService)

  private readonly companyFacade = inject(CompanyFacade)
  private readonly destroy$ = inject(DestroyDirective).destroy$

  forecast?: IForecastDto | null

  constructor() {}

  ngOnInit(): void {
    this.companyFacade.forecast$
      .pipe(
        takeUntil(this.destroy$),
        withLatestFrom(
          this.companyFacade.ticker$,
          this.translateService.get('forecast.notFoundForecastPageTitle')
        ),
        map(([forecast, ticker, notFoundMessage]) => ({ forecast, ticker, notFoundMessage })),
        filter(({ ticker }) => Boolean(ticker)),
        tap(({ forecast, ticker, notFoundMessage }) => {
          this.forecast = forecast
          forecast
            ? this.metaTagService.setTickerPageMeta(forecast.company.name, forecast.company.ticker)
            : this.metaTagService.setTickerNotFoundPageMeta(ticker!, notFoundMessage)
        })
      )
      .subscribe()
  }

  ngOnDestroy(): void {
    this.metaTagService.setHomePageMeta()
  }
}
